function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  id: "Path_1103",
  "data-name": "Path 1103",
  d: "M0,0H24V24H0Z",
  fill: "rgba(0,0,0,0)",
  clipRule: "evenodd"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1000",
  "data-name": "Group 1000",
  transform: "translate(0 24)"
}, React.createElement("g", {
  id: "Group_999",
  "data-name": "Group 999",
  transform: "translate(0 -24)"
}, React.createElement("g", {
  id: "Group_996",
  "data-name": "Group 996",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_995",
  "data-name": "Group 995"
}, React.createElement("path", {
  id: "Path_1102",
  "data-name": "Path 1102",
  d: "M0,0H24V24H0Z",
  fill: "rgba(0,0,0,0)",
  stroke: "rgba(112,112,112,0.01)",
  strokeWidth: 0
}))), React.createElement("g", {
  id: "Group_998",
  "data-name": "Group 998",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_997",
  "data-name": "Group 997"
}, React.createElement("path", {
  id: "Path_1104",
  "data-name": "Path 1104",
  d: "M3,9v6H7l5,5V4L7,9Zm13.5,3A4.5,4.5,0,0,0,14,7.97v8.05A4.474,4.474,0,0,0,16.5,12ZM14,3.23V5.29a7,7,0,0,1,0,13.42v2.06A8.994,8.994,0,0,0,14,3.23Z",
  fill: "#b4b6b8"
})))));

var SvgSoundOff = function SvgSoundOff(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSoundOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-off.4feaa0d9.svg";
export { ForwardRef as ReactComponent };